module.exports = __webpack_public_path__ + "img/356.6002fbe4.png";